import { Button, Input, message,Modal } from "antd";
import { useApproveRejectUnloading } from "features/unloading-log/use-cases/create-weighbride";
import { useState } from "react";

export const UnLoadingModelApproveReject = ({
  OpenModel,
  onClose,
  approveReJect,
  logData,
}: any) => {
  const [comment, setComment] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const { mutateAsync } = useApproveRejectUnloading();
  
  const handleOpenConfirm = () => {
    if (!comment.trim()) {
      message.error("Comment is required before proceeding.");
      
return;
    }
    setConfirmVisible(true); // ✅ open confirmation modal
  };

  const handleConfirm = async () => {
    try {
      const payload = {
        remarks: comment,
        unloadId:logData?.unloadingId,
        isApproved: approveReJect === "Approve" ? 1 : 3,
      };

      await mutateAsync(payload);
      message.success(
        approveReJect === "Approve"
          ? "Approved successfully"
          : "Rejected successfully"
      );

      setConfirmVisible(false);
      onClose();
    } catch (err) {
      message.error("Something went wrong, please try again.");
      console.error(err);
    }
  };

  return (
    <>
      {/* 🔹 First Modal - Add comment */}
      <Modal
        title={`Add comment before ${approveReJect.toLowerCase()}`}
        open={OpenModel}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOpenConfirm}>
            Submit
          </Button>,
        ]}
      >
        <Input.TextArea
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter your comment here..."
        />
      </Modal>

      {/* 🔹 Second Modal - Confirmation */}
      <Modal
        title={`Are you sure you want to ${approveReJect.toLowerCase()}?`}
        open={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setConfirmVisible(false)}>
            No
          </Button>,
          <Button key="ok" type="primary" onClick={handleConfirm}>
            Yes
          </Button>,
        ]}
      >
      </Modal>
    </>
  );
};
